const RoleSelector = ({onRoleChange}) => {	
	return (
		<select name='role' required
			className='form-control role-selector'
			onChange={(event) => onRoleChange(event.target.value)}
		>
			<option value=''>Select Role</option>
			<option
				value={
					'QA'
				}
			>
				Q.A.
			</option>
			<option
				value={
					'PI'
				}
			>
				P.I.
			</option>
		</select>
	);
};

export default RoleSelector;
